import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query getTeamReports($businessId: ID!, $duration: TeamReportDuration, $teamStates: [ReportingTeamState], $teamDate: TeamDateInput) {
    teamReports(businessId: $businessId, duration: $duration, teamStates: $teamStates, teamDate: $teamDate) {
      until
      reports {
        teamName
        overall
        engaged
        enabledUsers
        activeUsers
        managers
        activationRate
        perksUsage
        recognitionUsage
        wellnessUsage
        cultureHubUsage
        uuid
        teamState
        redemptions
      }
      availableDates {
        month
        year
      }
    }
  }
`

export const teamReportsKey = getQueryNames(query)[0]

export default query
